import { useInView } from 'react-intersection-observer';
import { useAnimation } from 'framer-motion';
import { useEffect } from 'react';

export const useScrollReveal = (threshold = 0.8, triggerOnce = true) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ 
    threshold, 
    triggerOnce,
    rootMargin: '0px 0px -200px 0px' // 섹션이 화면 하단에서 100px 위에 있을 때 트리거
  });

  useEffect(() => {
    if (inView) {
      // Start the 'animate' variant when the element enters the viewport
      controls.start('animate');
    }
  }, [inView, controls]);

  return { ref, controls, inView };
};

export const useScrollAnimation = (animation, threshold = 0.8) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold,
    triggerOnce: true,
    rootMargin: '0px 0px -200px 0px' // 섹션이 화면 하단에서 100px 위에 있을 때 트리거
  });

  if (inView) {
    controls.start(animation.animate);
  }

  return { ref, controls, animation };
};
